import React, { useState } from "react";
import StartOrderForm from "./StartOrderForm";
import { OrderStatusName, OrderType } from "../../enums";
import { useOrderDetails } from "../../contexts/orderDetails";
import OrderStatusForm from "./OrderStatusForm";
import {
  getInnerHtmlForPunchingPrev,
  getInnerHtmlForSlittingPrev,
} from "../../utils/lib";

export default function OrderDetailsFooter() {
  const [{ orderDetails }] = useOrderDetails();
  const [newUps, setNesUps] = useState("1");
  const {
    size,
    gap = 1,
    ups,
    label,
    roll,
    ready_roll,
    slitting_note,
    order_type,
    daya_mtr,
  } = orderDetails;

  const isPaperOrder = order_type === OrderType.Paper;
  const height = size?.split("X")[1];

  const perRollMeter = ((height * 1 + gap * 1) * label) / (ups * 1000);
  const perRollLabel = parseFloat(label / ups).toFixed(3);

  const remainingLabels = roll - (ready_roll || 0);

  const totlaLable = label * remainingLabels;

  const [orderStateData, setOrderStateData] = useState();
  const newMeter = parseFloat(
    (perRollMeter * remainingLabels) / newUps
  ).toFixed(3);

  function handelPunchinPrev() {
    var printDiv = getInnerHtmlForPunchingPrev(
      orderDetails,
      newUps * ups,
      newMeter,
      totlaLable
    );
    var printWindow = window.open(
      "",
      "",
      "left=0, top=0, width=800, height=500, toolbar=0, scrollbars=0, status=0"
    );
    printWindow.document.write(printDiv);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  }
  function handelSlittingPrev() {
    var printDiv = getInnerHtmlForSlittingPrev(orderDetails, newUps, newMeter);
    var printWindow = window.open(
      "",
      "",
      "left=0, top=0, width=800, height=500, toolbar=0, scrollbars=0, status=0"
    );
    printWindow.document.write(printDiv);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  }

  return (
    <div className="col-span-12 border border-gray-400 rounded-md">
      <OrderStatusForm
        orderStateData={orderStateData}
        setOrderStateData={setOrderStateData}
      />
      <div>
        <div className="grid grid-cols-12 gap-3">
          <div className="col-span-4 p-2">
            <div>
              {orderDetails?.order_status > 0 && (
                <div>
                  {isPaperOrder && (
                    <div>
                      <p> Total Meter : {daya_mtr} </p>
                    </div>
                  )}

                  {!isPaperOrder && (
                    <>
                      <div>
                        <p>
                          Total Meter :{" "}
                          {parseFloat(perRollMeter * remainingLabels).toFixed(
                            3
                          )}{" "}
                          Meter
                        </p>
                        <p>
                          Per Roll Meter : {parseFloat(perRollMeter).toFixed(3)}{" "}
                          Meter
                        </p>
                        <p>Total Label : {totlaLable}</p>
                        <p>Slitting : {perRollLabel} </p>
                      </div>
                      <div className="flex gap-4 items-center">
                        <select
                          name="ups"
                          onChange={(e) => {
                            setNesUps(e.target.value);
                          }}
                          value={newUps}
                          className="mt-1 block px-3 py-2 bg-white border  rounded-md text-sm shadow-sm placeholder-slate-400"
                        >
                          <option value="1">select ups</option>

                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                        Ups {newMeter} Meter
                      </div>
                    </>
                  )}
                </div>
              )}

              <div className="flex gap-4 mt-4 flex-wrap">
                {orderDetails?.order_status < 2 && (
                  <button
                    onClick={() =>
                      setOrderStateData({
                        type: "cancelOrder",
                        isEditMode: false,
                      })
                    }
                    className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-900 transition-colors "
                  >
                    Cancel Order
                  </button>
                )}
                {orderDetails?.order_status > 0 && (
                  <button
                    className="bg-navy-blue text-white p-1 rounded-md capitalize px-2"
                    onClick={handelPunchinPrev}
                  >
                    Punching Preview
                  </button>
                )}
                {orderDetails?.order_status > 2 && (
                  <button
                    onClick={handelSlittingPrev}
                    className="bg-navy-blue text-white p-1 rounded-md capitalize px-2"
                  >
                    Slitting Preview
                  </button>
                )}
                {orderDetails?.order_status > 0 && (
                  <button
                    onClick={() =>
                      setOrderStateData({
                        type: "slitting_note",
                        isEditMode: !!slitting_note,
                      })
                    }
                    className="bg-[#0a9f86] text-white px-2 py-1 rounded hover:bg-[#076e5d]  transition-colors "
                  >
                    {!slitting_note ? "Add" : "Edit"} Slitting Note
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-span-8 p-2">
            {orderDetails.order_status ==
              OrderStatusName["New/Not Accepted"] && <StartOrderForm />}
          </div>
        </div>
      </div>
    </div>
  );
}
